import { Injectable, Inject } from '@angular/core';
import { Http, Headers, Response, Request, RequestOptions, URLSearchParams, RequestMethod } from '@angular/http';
import { Observable, ReplaySubject, Subject } from 'rxjs';
import { TranslateService } from './translate.service';
import { ApiRequestService } from './api-request.service';

@Injectable()
export class RequirementService {

    constructor(
        private apiRequest: ApiRequestService,
        private translate: TranslateService
    ) { }



    getRequirementsMaster(): Observable<any> {
        let me = this;

        let requirementMasterDataSubject = new Subject<any>(); // Will use this subject to emit data that we want

        this.apiRequest.getCallWithAPIMapper('fetchAllRequirementMaster')
            .subscribe(jsonResp => {
                let returnObj = jsonResp;
                console.log(returnObj);
                requirementMasterDataSubject.next(returnObj); // incidentList is a Subject and emits an event thats being listened to by the components
            });

        return requirementMasterDataSubject;
    }
    getDocumentMaster(requirmentCd: String): Observable<any> {
        let me = this;

        let requirementMasterDataSubject = new Subject<any>(); // Will use this subject to emit data that we want

        let pathVariables = [];
        pathVariables.push(requirmentCd);
        this.apiRequest.getCallWithAPIMapper('fetchDocumentMasterByRequirementCd', null, null, pathVariables)
            .subscribe(jsonResp => {
                let returnObj = jsonResp;
                console.log(returnObj);
                requirementMasterDataSubject.next(returnObj); // incidentList is a Subject and emits an event thats being listened to by the components
            });

        return requirementMasterDataSubject;
    }

    uploadDocuments(documentObject: any): Observable<any> {
        let self = this;
        let DocumentDataSubject: Subject<any> = new Subject<any>();
        let DataList = [];
        this.apiRequest.postCallWithAPIMapper('documentSave', documentObject)
            .subscribe(jsonResp => {
                if (jsonResp !== undefined) {
                    console.log("Document upload successful")
                    console.log(jsonResp)

                    if (Array.isArray(jsonResp)) {
                        jsonResp.forEach(element => {
                            DataList.push(element);
                        });
                    }

                    DocumentDataSubject.next(DataList);
                    DocumentDataSubject.complete();

                } else {
                    console.log("Document upload failed")
                    console.log(jsonResp)
                }
                // DocumentDataSubject.next(jsonResp);

            }, errResp => {
                DocumentDataSubject.next(errResp);
            })
        return DocumentDataSubject;
    }

    fetchDocuments(entityGuid: any): Observable<any> {
        let me = this;

        let DocumentDataSubject = new Subject<any>();

        let pathVariables = [];
        pathVariables.push(entityGuid);
        this.apiRequest.getCallWithAPIMapper('documentFetchByEntityGuid', null, null, pathVariables)
        // this.apiRequest.getCallWithAPIMapper('documentFetchByEntityGuid' + entityGuid)
            .subscribe(jsonResp => {
                let returnObj = jsonResp;
                console.log(returnObj);
                DocumentDataSubject.next(returnObj);
            });

        return DocumentDataSubject;
    }






}


